// extracted by mini-css-extract-plugin
module.exports = {"o2-footer-nav-list":"o2-footer-navlist_o2-footer-nav-list__L1AMt"};